var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { "body-style": "padding:0 0 20px 0;" } },
        [
          _c("ueditorFrom", {
            ref: "ueditorFrom",
            attrs: {
              border: true,
              height: _vm.height,
              "main-width": "800px",
              "editor-border": false,
              placeholder: "支持上传组织架构图",
              content: _vm.content,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cr-bottom-button btn-shadow" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["hr:training:structure:save"],
                  expression: "['hr:training:structure:save']",
                },
              ],
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleConfirm()
                },
              },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }